export const PATIENTS_IN_QUEUE = "PATIENTS_IN_QUEUE";
export const DOCTORS_IN_QUEUE = "DOCTORS_IN_QUEUE";
